<script lang="ts">
export default {
  name: 'KkLabelSummaryHead'
}
</script>
<script lang="ts" setup>
import { computed } from 'vue'
import {useStore} from 'vuex'
import { toNumberLocaleString } from '../../../../modules/localeString'
import { KkLabelBrandedBadge } from '../../../analysis'
import type { LabelHeadItem, HeadIdKind } from '../../types'
import { useSearchKeywordImpressionLabels } from 'src/biz_spa/domains/management/composables'
const { companyUuid } = useSearchKeywordImpressionLabels()

const store = useStore()

interface Props {
  headId: HeadIdKind,
  headItem: LabelHeadItem[] | null
  caption: string
}

const editLabelId = computed(() => {
  return isBrandedLabel.value ? 'branded' : 'selected'
})

const isBrandedLabel = computed(() => props.headId === 'searchKeywordLabelBranded')
const showOnlyOwnerAuthority = computed<boolean>(() => store.getters['companiesAccessibleApi/showOnlyOwnerAuthority'])

const props = defineProps<Props>()
</script>

<template>
  <div>
    <div v-if="props.headItem">
      <div v-if="Array.isArray(props.headItem)">
        <div v-for="(item, index) in props.headItem" :key="`headItem_${index}`" :class="$style.headItem">
          <KkLabelBrandedBadge v-if="isBrandedLabel" :kind="item.name" :class="$style.badge" />
          <span :class="$style.countGroup">
            <span :class="$style.count">{{ toNumberLocaleString(item.impressionCount) }}</span>
            <span :class="$style.percent">（{{ toNumberLocaleString(item.rate) }} %）</span>
          </span>
          <br v-if="index < props.headItem.length - 1">
        </div>
      </div>
      <span :class="$style.caption">{{ props.caption }}</span>
    </div>
    <div v-else>
      <span :class="$style.hyphen">-</span><br>
      <router-link
        v-if="showOnlyOwnerAuthority"
        :to="{ name: 'CompaniesSearchKeywordImpressionLabelForm', params: { company_uuid: companyUuid, label_id: editLabelId} }"
        :class="$style.link"
      >
        {{ headId === 'searchKeywordLabelBranded' ? '指名' : '注目' }}ワードを設定する
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" module>
@import "../../../../../../stylesheets/biz_spa/foundation/var";

@import "../../../../../../stylesheets/biz_spa/foundation/mixin";
.headItem {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @include mq(sm) {
    flex-direction: row;
    align-items: center;
  }
}
.badge {
  margin-right: auto;
  width: 100%;

  @include mq(sm) {
    width: auto;
  }
}
.countGroup {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: auto;

  @include mq(lg) {
    flex-direction: row;
    align-items: center;
  }
}
.percent {
  font-weight: normal;
  font-size: 10px;
  position: relative;
  top: 2px;
}
.caption {
  display: block;
  font-weight: normal;
  font-size: 10px;
  margin-top: 8px;
}
.hyphen {
  font-weight: normal;
  font-size: 14px;
}
.link {
  font-weight: normal;
  font-size: 10px;
}
</style>
